import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  topFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}))
